module.exports = __webpack_public_path__ + "img/logo-header.1fc6ec9c.webp";